import CompanyPageContent from './CompanyPageContent';

export default CompanyPageContent;
